import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { RbacSodEffects } from './rbac-sod.effects';
import { rbacSodFeatureKey, rbacSodReducer } from './rbac-sod.reducer';

/**
 * Lazy registration for the RBAC + SoD feature slice (US #9320 / R1 #9357).
 *
 * Dropped into the lazy `rbac` route's `providers: []` in
 * `admin-console.routes.ts`, mirroring `provideAuditFeature()`. `app.config.ts`
 * already calls `provideStore()` + `provideEffects()` at the root level with
 * the explicit note that audit, rbac-sod, and workflow register lazily — this
 * is the rbac-sod half of that.
 *
 * The slice doesn't load until the user enters Admin Console → RBAC, so the
 * 140-key permission catalog + 11 personas + N user-scope rows stay out of the
 * initial bundle / state tree for users who never open the console.
 *
 * Example:
 * ```ts
 * {
 *   path: 'rbac',
 *   loadComponent: () => import('./rbac-sod-console/rbac-sod-console.component')
 *                          .then(m => m.RbacSodConsoleComponent),  // shipped by R2-R7
 *   providers: [provideRbacSodFeature()],
 * }
 * ```
 */
export function provideRbacSodFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(rbacSodFeatureKey, rbacSodReducer),
    provideEffects(RbacSodEffects),
  ]);
}
